import React from 'react';

import { Box } from '@rbilabs/components-library/build/components/layout';
import { noop } from 'lodash-es';
import { useIntl } from 'react-intl';

import ActionButton from 'components/action-button';
import Dialog from 'components/dialog';
import useMediaQuery from 'hooks/use-media-query';
import { useAuthContext } from 'state/auth';
import { allowsUnauthenticatedRedemption } from 'utils/offers';

import LoginRequiredDialog from './login-required-dialog';
import { MobileOrderingText } from './mobile-ordering-text';
import { IRedemptionMethodProps } from './types';

const OfferRedemptionMethodDialog: React.FC<IRedemptionMethodProps> = ({
  offer,
  isMobileAvailable,
  isRestaurantAvailable,
  onClickRestaurant,
  onClickMobile,
  onDismiss,
  ruleSet,
  shortCode,
}) => {
  const auth = useAuthContext();
  const { formatMessage } = useIntl();
  const isDesktop = useMediaQuery('desktop');
  const isLoggedIn = auth.isAuthenticated();

  if (!allowsUnauthenticatedRedemption(ruleSet) && !isLoggedIn) {
    return <LoginRequiredDialog onDismiss={onDismiss} />;
  }

  const handleButtonClick = () => {
    if (!isMobileAvailable) {
      return;
    }

    onClickMobile();
  };

  return (
    <Dialog
      onDismiss={onDismiss}
      heading={formatMessage({ id: 'serviceModePromptAlternative' })}
      actions={
        <>
          <Box minWidth="auto" width="100%">
            <ActionButton
              onlyIcon
              fullWidth
              disabled={!isMobileAvailable}
              onClick={handleButtonClick}
              data-testid="offer-redemption-mobile"
            >
              <MobileOrderingText isLoggedIn={isLoggedIn} isMobileAvailable={isMobileAvailable} />
            </ActionButton>
          </Box>
          <Box margin={isDesktop ? '0 0 0 1rem' : '1rem 0 0'} width="100%" minWidth="auto">
            <ActionButton
              onlyIcon
              fullWidth
              disabled={!isRestaurantAvailable || !shortCode}
              onClick={isRestaurantAvailable ? onClickRestaurant : noop}
              data-testid="offer-redemption-restaurant"
            >
              {formatMessage(
                isRestaurantAvailable
                  ? { id: 'inRestaurantOrder' }
                  : { id: 'restaurantOrderComingSoon' }
              )}
            </ActionButton>
          </Box>
        </>
      }
      offer={offer}
      modalAppearanceEventMessage={formatMessage({ id: 'orderRedemptionOrderType' })}
    />
  );
};

export default OfferRedemptionMethodDialog;
